<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const { locale } = useI18n();
// Keep weekday labels aligned with the Monday-first calendar columns.
const weekdays = computed(() =>
  Array.from({ length: 7 }, (_, index) => ({
    label: new Intl.DateTimeFormat(locale.value, { weekday: 'narrow' }).format(
      new Date(2024, 0, index + 1)
    ),
    name: new Intl.DateTimeFormat(locale.value, { weekday: 'long' }).format(
      new Date(2024, 0, index + 1)
    ),
  }))
);
</script>

<template>
  <div class="w-full grid grid-cols-7 gap-1">
    <div
      v-for="(day, index) in weekdays"
      :key="index"
      class="flex items-center justify-center font-medium text-xs h-7"
    >
      <abbr :title="day.name" class="no-underline">{{ day.label }}</abbr>
    </div>
  </div>
</template>
